import React from 'react'

class InstrumentLogDiv extends React.Component {
    state = {
        id: this.props.id || 0,
        instrumentID: this.props.instrumentID || 0,
        planName: this.props.planName || '',
        readOnly: this.props.readOnly || false,
    }

    componentDidMount = () => {
        this.doGetInstrumentLog()
    }

    doGetInstrumentLog = () => {
        const { id, instrumentID, planName } = this.state
        Tyan.doPostEvent('GetInstrumentLog', {
            data: { id, instrumentID, planName },
            onEnd: ({ errorMessage, optionsParas, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ optionsParas, initValues基本信息, changedValues基本信息: {} })
                }
            }
        })
    }

    handlerSave = () => {
        const { onClose, onRefresh } = this.props
        const { instrumentID, planName } = this.state
        Tyan.doPostEvent('SaveInstrumentLog', {
            data: { instrumentID, planName, ...Tyan.utility.getChangedFieldsets(this, '基本信息', false) },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    onClose && onClose()
                    onRefresh && onRefresh()
                }
            }
        })
    }

    handlerDelete = () => {
        const { onClose, onRefresh } = this.props
        const { id } = this.state

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent('DelInstrumentLog', {
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    } else {
                        Ext.toast('删除成功')
                        onRefresh && onRefresh()
                        onClose && onClose()
                    }
                }
            })
        )
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }


    canSave = () => {
        return this.bChanged() && !Tyan.checkForm.checkLimited(this)
    }

    bChanged = () => {
        return Tyan.utility.hasChangedValues(this)
    }


    fieldset基本信息 = () => {
        const i_类型 = Tyan.utility.getInitValue(this, '基本信息', '类型')
        return [
            { _text: '设备', disabled: true },
            { _text: '类型', disabled: true, cdt: () => i_类型 },
            { _select: '类型', required: !i_类型, cdt: () => !i_类型 },
            { _date: '日期', required: true },
            { _text: '负责人', required: true },
            { _text: '原因', maxRows: 3 },
            { _text: '备注' },
            { _files: '附件' },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { id, readOnly, initValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />

        return <Body data={this} maxWidth={600}
            controls={
                readOnly && [
                    { _button: '删除', handler: this.handlerDelete, cdt: () => id > 0 },
                    { _button: '关闭', handler: this.handlerClose }
                ] || [
                    { _button: '保存', handler: this.handlerSave, disabled: !this.canSave() },
                    { _button: '删除', handler: this.handlerDelete, cdt: () => id > 0 },
                    { _button: this.bChanged() && '取消' || '关闭', handler: this.handlerClose },
                ]
            }
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly },
                ]}
        />
    }
}

export default InstrumentLogDiv